<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'chi-square-table-4';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.chi-square-table-4 {
  $height: 48px;
  $padding: 4px;
  --header-cell-height: #{$height};
  --body-cell-height: #{$height};
  $border: 1pt solid #c0bec7;
  thead {
    tr {
      &:not(:first-child) {
        th {
          background: var(--theme-color-1);
          & > div {
            color: #fff;
          }
        }
      }
      &:first-child {
        th {
          & > div {
            padding: 0 24px;
          }
        }
      }
      &:nth-child(2) {
        th[rowspan='1'] {
          div {
            border-bottom: 1pt solid #fff;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          font-size: 14px;
          border-left: $border;
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
      &:first-child,
      &:nth-last-child(2),
      &:has(td:nth-child(2).empty) {
        --body-cell-height: #{$height + $padding};
      }
      &:first-child {
        td {
          & > div {
            padding-top: $padding;
          }
        }
      }
      &:nth-last-child(2) {
        td {
          & > div {
            padding-bottom: $padding;
          }
        }
      }
      .empty {
        & > div {
          border-bottom: none;
        }
      }
      &:has(td:nth-child(2).empty) {
        border-top: $border;
        border-bottom: 2pt solid var(--theme-color-1);
        td {
          &:not(:first-child) {
            div {
              border-left: none;
            }
          }
        }
      }
    }
  }
}
</style>
